import { create } from "zustand"

import {
  type SortingOrder,
  type User,
  type UserSortField,
  UsersListDocument,
  type UsersListQuery,
} from "@/graphql/codegen/graphql"
import { type SearchFilters, createSearchStore } from "@/stores/createSearchStore"

export type UsersSearchFilters = SearchFilters & {
  field?: UserSortField
  order?: SortingOrder
}

const deduplicateData = (newData: User[], existingData: User[]): User[] => {
  const uniqueIds = new Set(existingData.map((user) => user.userId))
  return [...existingData, ...newData.filter((user) => !uniqueIds.has(user.userId))]
}

export const useUsersSearchStore = create(
  createSearchStore<User, UsersSearchFilters, UsersListQuery>({
    documentNode: UsersListDocument,
    deduplicateData,
    getQueryInput: (filters: UsersSearchFilters, offset: number, limit: number) => {
      const { field, order, ...otherFilters } = filters
      return {
        filter: otherFilters,
        offset,
        limit,
        sort: { field, order },
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: data.user.list.__typename,
      data: data?.user.list.__typename === "UserListSuccess" ? (data.user.list.users as User[]) : [],
      error: data?.user.list.__typename === "UserListFailure" ? data.user.list.error : undefined,
    }),
  })
)
